import React, { Component } from 'react';
import JobsForJpin from './JobsForJpin.js';

export default class JpinJobsDashboard extends Component {

	pickJobs(pickJobs, putJobs) {
		return (
			<div>
				{
					(pickJobs.length > 0) ?
						<div>
							Product is not picked yet
						</div> : null}
			</div>
		)
	}

	getJobsPerUser(users) {
		var usersData = users.map((user, index) => {
			return (
				<div className="putaway-pallet-outer" key={index}>
					<div className="sixteenFont">{user.userNameAndPhoneNo}</div>
					<div className="row putaway-product-label" style={{ marginTop: '15px' }}>
						<div className="col-xs-6 col-sm-4 col-md-4">Pick Qty</div>
						<div className="col-xs-6 col-sm-4 col-md-4">Put Qty</div>
					</div>
					<div className="row putaway-product-value" style={{ marginTop: '5px' }}>
						<div className="col-xs-6 col-sm-4 col-md-4">{user.totalPickQty}</div>
						<div className="col-xs-6 col-sm-4 col-md-4">{user.totalPutQty}</div>
					</div>
					<div style={{ marginTop: '15px' }}>
						{(user.pickLocations.length > 0) ?
							<div >
								<div style={{ fontSize: '16px' }}>
									Product is not picked yet.
								</div>
								{
									user.pickLocations.map((loc, index) => {
										return <div key={index}><JobsForJpin loc={loc} /></div>
									})
								}
							</div> : null
						}
						{(user.putLocations.length > 0) ?
							<div>
								<div style={{ fontSize: '16px' }}>
									Product is picked but not dropped.
								</div>
								{
									user.putLocations.map((loc, index) => {
										return <div key={index}><JobsForJpin loc={loc} /></div>
									})
								}
							</div> : null
						}
					</div>
				</div>
			);
		})
		return usersData;
	}

	render() {
		var details = this.props.jobDetails;
		return (
			<div>
				<div className="white-product-box">
					<div className="row">
						<div className="col-xs-5 col-sm-3 col-md-2 centralized">
							<img src={details.imageUrls[0]} alt="product" style={{ maxWidth: '100%', height: '100px' }} />
						</div>
						<div className="col-xs-7 col-sm-9 col-md-10">
							{details.productTitle}
						</div>
					</div>
				</div>

				<div style={{ padding: '0 15px' }}>
					{this.getJobsPerUser(details.pendingJobStepResponses)}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JpinJobsDashboard.js